import React from 'react';
import { Stack } from '@mui/material';

import { EliceTooltip } from '../tooltip';
import type { EliceTooltipProps } from '../tooltip';

import AIAvatar from '../../assets/AIAvatar.png';

export type EliceAIFeedbackProps = Omit<EliceTooltipProps, 'children'> & {
  CustomAvatar?: React.ReactNode;
};

const EliceAIFeedback = ({
  title,
  placement = 'left',
  CustomAvatar,
  ...rest
}: EliceAIFeedbackProps) => {
  return (
    <EliceTooltip
      title={title}
      placement={placement}
      {...rest}
      isControl
      triggerAction="click"
    >
      <Stack
        position="relative"
        width="fit-content"
        height="fit-content"
        maxWidth="100%"
        maxHeight="100%"
      >
        {CustomAvatar ?? <img src={AIAvatar} alt="AI Avatar" />}
      </Stack>
    </EliceTooltip>
  );
};

export default EliceAIFeedback;
